module.exports = __webpack_public_path__ + "img/jzjk-en.bc19b338.png";